import { Form, Formik } from "formik";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import {
  SIGNATURE_MAIL_INITIAL_VALUES,
  signatureMailSchema,
} from "../../models/monCompte";
import TextArea from "../UI/TextArea";
import Callout from "../UI/Callout";
import { handleAPIError } from "../../utils/index.jsx";
import { useState } from "react";
import styles from "./SignatureMailForm.module.css";

export default function SignatureMailForm({ onSave, customization }) {
  const [error, setError] = useState("");
  async function submitHandler(values) {
    setError("");
    try {
      await onSave(sanitizeValues(values));
    } catch (e) {
      setError(handleAPIError(e));
    }
  }

  const initialValues = toInitialValuesFromSchema(
    signatureMailSchema,
    { mail_signature: customization?.mail_signature },
    SIGNATURE_MAIL_INITIAL_VALUES,
  );

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={signatureMailSchema}
      onSubmit={submitHandler}
    >
      <Form className={styles.form}>
        <TextArea
          name={"mail_signature"}
          rows="6"
          label={"Signature"}
          marginForm=""
        ></TextArea>

        <div className={"text-right"}>
          <FormikSubmitButton>Valider</FormikSubmitButton>
        </div>
        <Callout variant="danger">{error}</Callout>
      </Form>
    </Formik>
  );
}
